// Only these fields may leave the browser in a save/completion diagnostic.
export function createSupportReference() {
  const values = new Uint32Array(2);
  if (window.crypto?.getRandomValues) {
    window.crypto.getRandomValues(values);
  } else {
    // A support reference is a correlation label, never an authentication token.
    values[0] = Date.now() >>> 0;
    values[1] = Math.floor(Math.random() * 0x100000000);
  }
  return Array.from(values, value => value.toString(16).padStart(8, "0")).join("").toUpperCase();
}

const safeIdentifier = value => typeof value === "string" && /^[a-zA-Z0-9-]{1,64}$/.test(value) ? value : undefined;

export function isConfirmedSaveResponse(response, assessmentInstanceId, taskId) {
  const answer = response?.data;

  return Boolean(
    response?.status >= 200 &&
      response.status < 300 &&
      answer &&
      !answer.statusCode &&
      !answer.error &&
      typeof answer.id === "string" &&
      answer.id &&
      answer.assessmentInstanceId === assessmentInstanceId &&
      answer.taskId === taskId
  );
}

export function createDiagnostic({ supportReference, operation, assessmentInstanceId, taskId, httpStatus, code }) {
  return JSON.stringify({
    supportReference: safeIdentifier(supportReference),
    operation: operation === "verify_completion" ? operation : "save_task_answers",
    assessmentInstanceId: safeIdentifier(assessmentInstanceId),
    taskId: safeIdentifier(taskId),
    build: safeIdentifier(process.env.REACT_APP_BUILD_SHA),
    timestamp: new Date().toISOString(),
    httpStatus: Number.isInteger(httpStatus) ? httpStatus : undefined,
    code: ["SAVE_UNCONFIRMED", "INVALID_SAVE_RESPONSE", "INVALID_SAVE_CONTEXT", "COMPLETION_UNCONFIRMED"].includes(code) ? code : "SAVE_UNCONFIRMED",
  });
}
